import { type FaqItem } from '../types';
import { APP_NAME } from '@glow/shared/lib/constants';

export const clientFaqItems: FaqItem[] = [
  {
    question: `${APP_NAME} — это салон красоты?`,
    answer: `
      Нет. ${APP_NAME} — это сервис по поиску и записи к бьюти-мастерам и в салоны красоты. Поможем вам найти мастера рядом с домом, работой или удобной станцией метро. Выберите своего специалиста по стоимости, рейтингу и отзывам.
    `,
  },
  {
    question: `Услуги сервиса ${APP_NAME} платные?`,
    answer: `Вы пользуетесь сервисом бесплатно. Оплачивается только стоимость услуги мастеру напрямую. На сайте ${APP_NAME} ничего оплачивать не нужно.`,
  },
  {
    question: `Записываться через ${APP_NAME} дороже, чем напрямую?`,
    answer: `Нет, цены в ${APP_NAME} не отличаются от цен в салонах красоты или у частных специалистов. Наоборот. У многих мастеров через ${APP_NAME} даже дешевле. Максимальная скидка на услуги — до 50%.`,
  },
  {
    question: `Как записаться на процедуру через ${APP_NAME}?`,
    answer:
      'Вы выбираете мастера, удобную дату и время и фиксируете запись. Все действия выполняются в онлайн-формате с любого устройства в пару кликов.',
  },
  {
    question: `${APP_NAME} проверяет мастеров?`,
    answer: `
      <p>Мы понимаем, насколько серьезно вы относитесь к выбору салона и мастера, ведь вы доверяете свою внешность.</p>
      <p>Чтобы ваш выбор был сделан правильно и вы получили максимальное удовольствие от визита к мастеру и результата его работы, мы создали честную рейтинговую систему.</p>
      <p>За нарушение правил сервиса мастера будут сразу удалены с площадки навсегда.</p>
    `,
  },
  {
    question: 'Как формируется рейтинг салонов и бьюти-мастеров?',
    answer: `
      <p>Рейтинг формируется в зависимости от оценок клиентов — от 1 до 5 баллов.</p>
      <p>Если клиент в восторге от мастера, он может поставить максимально высокую оценку и написать положительный отзыв.</p>
      <p>Если клиент остался недоволен, был возмущен неопрятностью, хамским поведением или непрофессионализмом, он также может отразить это в оценке и комментарии в профиле мастера.</p>
      <p>Негативные отзывы мы не удаляем. У нас все честно. Благодаря обратной связи от клиентов другим пользователям намного проще выбрать подходящего специалиста и не разочароваться.</p>
    `,
  },
];
